import copy from "clipboard-copy";
import { BaseSyntheticEvent, useContext, useState } from "react";
import { Alert } from "react-bootstrap";
import { TiExport } from "react-icons/ti";
import TooltipConfig from "../../../../../components/Tooltip";
import { HomeContext } from "../../../../../contexts/Home/HomeContext";

const ExportButton = ({ id }: { id: string }) => {
  const { exportDashboard } = useContext(HomeContext);
  const [sucess, setSucess] = useState<boolean>(true);

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  const [showAlert, setShowAlert] = useState(false);

  const handleExport = () => {
    exportDashboard(id).then((exportCode) => {
      copyText(exportCode ? JSON.stringify(exportCode) : "");
    });
  };

  const copyText = async (exportCode: string) => {
    try {
      await copy(exportCode);
      setSucess(true);
      handleShowAlert();
    } catch (error) {
      setSucess(false);
      handleShowAlert();
    }
  };

  const handleShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000); // Fecha o alerta após 5 segundos
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: "10px",
          right: "10px",
          zIndex: 999,
        }}
      >
        {showAlert && (
          <Alert
            variant= {sucess ? "success" : "danger"}
            onClose={() => setShowAlert(false)}
            dismissible
          >
            {sucess
              ? "Codígo da página copiado!"
              : "Erro ao copiar codígo da página!"}
          </Alert>
        )}
      </div>

      <TooltipConfig
        content={["Exportar Página"]}
        children={
          <TiExport
            onMouseOver={MouseOver}
            size={26}
            onClick={() => handleExport()}
          />
        }
        placement={"bottom"}
        style={true}
      />
    </>
  );
};

export default ExportButton;
